import PropTypes from 'prop-types';

export const ImageWithCustomPropTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export const ImageWithDefaultProps = {
  width: 'auto',
  height: 'auto',
  loading: 'lazy',
};
